<main [style]="'--packages-length: ' + packagesLenght + ';'">

  <!-- título -->
  <div class="pme-container">
    <div class="title-container">
      <div class="left-title">
        <p class="main-left-title">Escolha seu novo pacote de créditos</p>
        <p class="sub-left-title">para consultar ou cobrar clientes</p>
      </div>

      <div class="right-title">
        <p class="main-right-title">Consulta de CPF/CNPJ e Cobrança de Dívidas</p>
        <p class="sub-right-title">A recarga escolhida será feita somente quando seu <strong>crédito for igual ou menor
            que R$ {{automaticRecharge}}</strong></p>
      </div>

    </div>
    <div class="divider">
      <mat-divider inset></mat-divider>
    </div>
  </div>
  <!-- fim título -->

  <!-- Produtos de consulta (Recarga garantida) -->

  <div class="container-consulta">
    <p class="title-packages">Escolha seu pacote de créditos:</p>

    <!-- produtos consulta (recarga garantida) -->
    <div class="container-consulta-products">
      <div class="products-container">
        <button *ngIf="this.needSlider" class="slider-btn-left" (click)="sliderAction('left')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#FA0D89"
              d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
          </svg>
        </button>
        <div class="product-container-card" *ngFor="let plan of packages; let i = index">
          <pme-product-consulta [productData]="packages[i]" (buyClicked)="navigate($event)" [elementIndex]="i"
            [shopWindowReduced]="false">
          </pme-product-consulta>

        </div>
        <button *ngIf="this.needSlider" class="slider-btn-right" (click)="sliderAction('right')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#FA0D89"
              d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
          </svg>
        </button>
      </div>
    </div>

  </div>

  <!-- fim produtos consulta (recarga garantida)  -->


  <!-- Tabela < 1280 -->

  <div class="table-container AA display-utils-hide-gt-md">
    <div class="table-title-container">
      <p class="table-title">Tabela de <strong>preços</strong></p>
      <p class="table-description">Consulte a tabela abaixo para entender o valor de cada consulta e quantas soluções
        você poderá utilizar.</p>

    </div>
    <div class="tabela no-margin" *ngIf="(packages && packages[0] )" [style]="{'padding-top': '16px'}">

      <div class="solutions-swiper">
        <div class="solutions">
          <div class="table-header" style="height: 44px;"></div>
          <div>
            <div class="table-content package-name" *ngFor="let feature of packages[this.packageIndex].featureList">
              <p>{{feature.name}}</p>
            </div>
          </div>
        </div>
        <swiper-container *ngIf="packages" slides-per-view="auto" free-mode="true" (slidechange)="onSwipe()" class="price-table">

          <swiper-slide *ngFor="let consultaPackage of packages; let i = index">

            <div class="column">
              <div class="table-header buy-button">

                <div>
                  <div class="discount"
                    *ngIf="(consultaPackage.appliedDiscounts && consultaPackage.appliedDiscounts.length && consultaPackage.discountsType === 'NON_EXTRA_BALANCE_ONLY'); else baseValue">

                    <span class="discount-mark">Pacote R$
                      {{formatCurrency(consultaPackage.baseValue)}}</span>
                    <div>
                      <p>Pacote R$</p><b> {{formatCurrency(consultaPackage.totalValue)}}</b>
                    </div>
                  </div>
                  <ng-template #baseValue>
                    <div>
                      <p>Pacote R$ {{formatCurrency(consultaPackage.baseValue)}}</p>
                    </div>
                  </ng-template>
                </div>

              </div>
              <div class="table-content"
                *ngFor="let value of getValuesBasedOnFeatureList(packages[this.packageIndex].featureList, consultaPackage)">
                <p>{{ value ? value + "/un" : "--" }}</p>


              </div>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>

    </div>


    <section class="plans-section">
      <h2>Entenda mais sobre as soluções de <strong>Consulta e Cobrança</strong></h2>

      <div class="plan-list-container">
        <div class="plan-list">
          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Consulta completa</strong></p>
            </div>
            <span>Análise completa indicada para conhecer seus parceiros de negócio.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Consulta intermediária</strong></p>
            </div>
            <span>Análise simples para conferir a situação atual dos seus clientes recorrentes antes de
              vender.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Identificador de dívidas</strong></p>
            </div>
            <span>Verifique rapidamente se o CNPJ ou CPF possui ou não dívidas registradas, sem
              detalhamento.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Antifraude Cadastral</strong></p>
            </div>
            <span>Confirme dados cadastrais e previna-se contra fraudes de identidade e laranjas.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Cobrança digital</strong></p>
            </div>
            <span>Conte com a cobrança digital (SMS e E-mail) sem desgastar a imagem da sua
              empresa.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Cobrança completa</strong></p>
            </div>
            <span>Benefícios da cobrança digital + negativação e acelere o pagamento de seus
              devedores.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Recomenda PF</strong></p>
            </div>
            <span>Saiba a melhor política de crédito para cada perfil e tenha até 30% a mais de
              aprovações de crédito.</span>
          </div>

          <div class="plan-item">
            <div class="plan-title">

              <p><strong>Recomenda PJ</strong></p>
            </div>
            <span>Saiba a melhor política de crédito para cada perfil e tenha até 30% a mais de
              aprovações de crédito.</span>
          </div>
        </div>
      </div>

    </section>
    <div class="divider divider-payment">
      <mat-divider inset></mat-divider>
    </div>
    <div class=" payment-methods pme-my-plan-payment-methods">

      <p>Formas de pagamento</p>

      <div class="payment-brands">
        <ng-container *ngFor="let image of paymentMethodsImages">
          <img src="/assets/images/payment-methods/{{image}}">
        </ng-container>
      </div>
    </div>

  </div>

  <!-- Fim Tabela <1280 -->
  <div class="divider divider-top-table">
    <mat-divider inset></mat-divider>
  </div>


  <!-- table pré-pago >1280 -->
  <div class="table-container BB display-utils-only-gt-md">
    <div class="table-title-container">
      <p class="table-title">Tabela de <strong>preços</strong></p>
      <p class="table-description">Consulte a tabela abaixo para entender o valor de cada consulta e quantas soluções
        você poderá utilizar.</p>
    </div>

    <div class="tabela" *ngIf="packages && packages[0]">

      <div class="solutions">
        <div class="table-header"></div>
        <div>
          <div class="table-content package-name" *ngFor="let feature of packages[this.packageIndex].featureList">
            <p>{{feature.name}}</p>
          </div>
        </div>
      </div>

      <div class="price-table  " *ngIf="packages">

        <div *ngFor="let consultaPackage of packages; let i = index" class="price-table-column ">
          <div class="column">
            <div class="table-header buy-button">

              <div>
                <div class="discount"
                  *ngIf="(consultaPackage.appliedDiscounts && consultaPackage.appliedDiscounts.length && consultaPackage.discountsType === 'NON_EXTRA_BALANCE_ONLY'); else baseValue">
                  <span class="discount-mark">Pacote R$
                    {{formatCurrency(consultaPackage.baseValue)}}</span>
                  <div>
                    <p>Pacote R$ </p><b> {{formatCurrency(consultaPackage.totalValue)}}</b>

                  </div>
                </div>
                <ng-template #baseValue>
                  <div>
                    <p>Pacote R$ {{formatCurrency(consultaPackage.baseValue)}}</p>

                  </div>
                </ng-template>
              </div>

            </div>
            <div class="table-content"
              *ngFor="let value of getValuesBasedOnFeatureList(packages[0].featureList, consultaPackage)">
              <p>{{ value ? value + "/un" : "--" }}</p>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider divider-bottom-table">
      <mat-divider inset></mat-divider>
    </div>
    <section class="plans-section">
      <h2>Entenda mais sobre as soluções de <strong>Consulta e Cobrança</strong></h2>
      <div class="plan-list">
        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Consulta completa</strong></p>
          </div>
          <span>Análise completa indicada para conhecer seus parceiros de negócio.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Consulta intermediária</strong></p>
          </div>
          <span>Análise simples para conferir a situação atual dos seus clientes recorrentes antes de
            vender.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Identificador de dívidas</strong></p>
          </div>
          <span>Verifique rapidamente se o CNPJ ou CPF possui ou não dívidas registradas, sem
            detalhamento.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Antifraude Cadastral</strong></p>
          </div>
          <span>Confirme dados cadastrais e previna-se contra fraudes de identidade e laranjas.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Cobrança digital</strong></p>
          </div>
          <span>Conte com a cobrança digital (SMS e E-mail) sem desgastar a imagem da sua empresa.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Cobrança completa</strong></p>
          </div>
          <span>Benefícios da cobrança digital + negativação e acelere o pagamento de seus
            devedores.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Recomenda PF</strong></p>
          </div>
          <span>Saiba a melhor política de crédito para cada perfil e tenha até 30% a mais de aprovações
            de crédito.</span>
        </div>

        <div class="plan-item">
          <div class="plan-title">

            <p><strong>Recomenda PJ</strong></p>
          </div>
          <span>Saiba a melhor política de crédito para cada perfil e tenha até 30% a mais de aprovações
            de crédito.</span>
        </div>
      </div>
    </section>


    <div class="divider divider-payment">
      <mat-divider inset></mat-divider>
    </div>
    <div class="payment-methods pme-my-plan-payment-methods">

      <p>Formas de pagamento</p>
      <div class="payment-brands">
        <ng-container *ngFor="let image of paymentMethodsImages">
          <img src="/assets/images/payment-methods/{{image}}">
        </ng-container>
      </div>
    </div>
    <div class="divider divider-payment">
      <mat-divider inset></mat-divider>
    </div>
  </div>


  <!-- Fim table pré-pago > 1280 -->
</main>